<template>
    <div component="TableCellTextEditor" ref="editor" :class="{ editing, selected }">
        <div ref="input" class="input" :contenteditable="editing" @keypress="keypress" @keyup.escape="close">
            {{ value }}
        </div>
        <div class="ribbon">
            <btn
                class="edit"
                @click.stop="edit"
                :icon="'edit'"
                tpos="none"
                radius="circle"
                color="ghost"
                v-if="getIsLoggedIn"
            />
            <btn
                class="drag handle"
                :icon="'import_export'"
                tpos="none"
                radius="circle"
                color="ghost"
                v-if="getIsLoggedIn && !editing"
            />

            <div class="controls">
                <btn class="no" @click.stop="close" :icon="'close'" tpos="none" radius="circle" color="ghost" />
                <btn class="yes" @click.stop="save" :icon="'done'" tpos="none" radius="circle" color="ghost" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'TableCellTextEditor',

    props: {
        value: {
            type: String,
            required: true,
            default: '',
        },

        kluc: {
            type: String,
            required: false,
            default: '',
        },

        row: {
            type: Object,
            required: true,
            default: {},
        },

        selected: {
            type: Boolean,
            required: false,
            default: false,
        },

        isEditing: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            editing: false,
            lastValue: '',
            content: this.value,
        };
    },

    computed: {
        getIsEdited() {
            return this.editing && this.selected;
        },
        ...mapGetters(['getIsLoggedIn']),
    },

    watch: {
        isEditing() {
            this.editing = this.isEditing;
        },

        selected() {
            // this.editing = this.selected
            if (!this.selected) this.close();
        },
    },

    methods: {
        keypress(event) {
            var keycode = event.charCode || event.keyCode;
            if (keycode == 13) {
                //Enter key's keycode
                this.save();
                return false;
            }
        },

        edit() {
            this.editing = true;
            this.$emit('editing', true);
            setTimeout(() => {
                var el = this.$refs.editor.querySelector('.input');
                var range = document.createRange();
                var sel = window.getSelection();
                range.setStart(el.childNodes[0], 0);
                // range.setEnd(el.childNodes[0],5);
                // range.setEnd(el,4);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
                el.focus();
            }, 1);

            function caret_position(id) {
                var d = document.getElementById(id);
                d.focus();
                d.selectionStart = d.value.length;
                d.selectionEnd = d.value.length;
            }

            // caret_position('id_of_form_field');
        },

        save() {
            this.$emit('save', this.row, this.kluc, this.$refs.input.textContent);
            this.editing = false;
        },

        close() {
            this.$emit('editing', false);
            this.editing = false;
            this.$refs.input.textContent = this.value;
        },
    },

    components: {},
};
</script>
<style lang="less">
@import '~@variables';

[component='TableCellTextEditor'] {
    .flex-row;
    user-select: none;
    cursor: pointer;
    transition: 0.3s;
    min-height: 25px;
    line-height: 25px;
    position: relative;
    overflow: hidden;

    &:hover {
        .ribbon {
            pointer-events: all;
            transform: scale(1);
            opacity: 1;
        }
    }

    &.selected {
        @media (max-width: 768px) {
            .ribbon {
                pointer-events: all;
                transform: scale(1);
                opacity: 1;
            }
        }
    }

    &.editing {
        cursor: text;

        .input {
            border-color: @dark;
        }

        .ribbon {
            width: 80px;
            pointer-events: all;
            transform: scale(1);
            opacity: 1;

            .controls {
                right: 0px;
            }
        }

        .edit {
            transform: translateX(-100%);
            opacity: 0;
        }
    }

    .input {
        width: 100%;
        margin: 0;
        padding: 5px;
        .radiusXxl;
        border: 1px solid transparent;
        transition: 0.3s;
        outline: 0px;
        line-height: 1.2;
        word-break: break-word;

        &:focus {
            outline: 0px;
        }
    }

    .ribbon {
        // position: absolute;
        display: flex;
        right: 0;
        top: 0;
        transition: 0.3s;

        transform: scale(0.5);
        opacity: 0;
        pointer-events: none;

        margin-right: 3px;

        button {
            font-weight: bold;
            height: 26px;
            min-height: 26px;
            width: 26px;
            min-width: 26px;

            .icon {
                min-height: 26px;
                min-width: 26px;
            }
        }

        .edit {
            transition: 0.3s;
            margin-left: 5px;
        }

        .drag {
            margin-left: 5px;
            cursor: move;
        }

        .controls {
            display: flex;
            position: absolute;
            right: -80px;
            transition: 0.3s;

            .yes {
                margin-left: 3px;
            }
        }
    }
}
</style>
